export const userCsvTemplate =
  "first_name,last_name,user_login,routing_profile_name,security_profile_names,softphone_auto_accept,acw_timeout,agent_hierarchy";
